export const ROUTER_PATHS = {
  language: ':language?',
  communityHome: 'community',
  communityGroups: 'community/groups',
  communityGroupsDetails: 'community/groups/:groupSlug',
  // TODO: remove this when melways is merged and ready
  communityThreadDetails: 'community/threads/:threadSlug',
  communityThreadDetail: 'community/groups/:groupSlug/threads/:threadSlug',
  languageCommunityHome: ':langugage/community',
  languageCommunityGroups: ':langugage/community/groups',
  languageCommunityGroupsDetails: ':langugage/community/groups/:groupSlug',
  // TODO: remove this when melways is merged and ready
  languageCommunityThreadDetails: ':langugage/community/threads/:threadSlug',
  languageCommunityThreadDetail:
    ':langugage/community/groups/:groupSlug/threads/:threadSlug',
};

export const NAV_PATHS = {
  language: '/:language?',
  communityHome: '/community',
  communityGroups: '/community/groups',
  communityGroupsDetails: '/community/groups/:groupSlug',
  // TODO: remove this when melways is merged and ready
  communityThreadDetails: '/community/threads/:threadSlug',
  communityThreadDetail: '/community/groups/:groupSlug/threads/:threadSlug',
  communityThreads: '/community/threads',
  languageCommunityHome: '/:langugage/community',
  languageCommunityGroups: '/:langugage/community/groups',
  languageCommunityGroupsDetails: '/:langugage/community/groups/:groupSlug',
  // TODO: remove this when melways is merged and ready
  languageCommunityThreadDetails: '/:langugage/community/threads/:threadSlug',
  languageCommunityThreadDetail:
    '/:langugage/community/groups/:groupSlug/threads/:threadSlug',
};
